import { Button } from '@material-ui/core';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react'
import { showErrorSnackbar } from '../../common/common.service';
import Loading from '../../components/shared/Loading';
import { login, logout, submitOtp } from './login.service';
import styles from './styles';
import validationSchema from './login.validation';


import firebase               from    'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
/*window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('sign-in-button', {
    'size': 'invisible',
    'callback': (response) => {
      // reCAPTCHA solved, allow signInWithPhoneNumber.
      onSignInSubmit();
    }
  });*/
declare global {
    interface Window { recaptchaVerifier: any,confirmationResult:any }
}

export default function Login(props: any) {
    const [ loading, setLoading ] = useState<boolean>(false);
    const [ otpContainer, setOtpContainer ] = useState<boolean>(false);
    const [ otp, setOtp ] = useState("");
    const [ phone, setPhone ] = useState("");
    const snackbar = useSnackbar();
    const formik = useFormik({
        initialValues: {
            email: '',
            pin: ''
        },
        validationSchema,
        onSubmit: handleSubmit
    })

    function handleSubmit(values: any) {
        setLoading(true);
        console.log(values)
        setPhone(values.number)
        login(values.number).then((data: any) => {
            setLoading(false)
            if(data.otpSend){
                setOtpContainer(true)
            }
             else {
                let errorMessage = '';
                switch(data.reason) {
                    case 'PIN':
                        errorMessage = 'Pin is incorrect!';
                        break;
                    case 'EMAIL':
                        errorMessage = 'Seems like the your email is not registered!';
                        break;
                    case 'NOT_REG':
                        errorMessage = 'Your account is not active, contact our admin!';
                        break;
                    default:
                        errorMessage = 'Something went wrong!'
                }
                showErrorSnackbar(
                    snackbar,
                    errorMessage,
                    true
                );
            }
        }).catch(err => {
            setLoading(false);
            console.log(err);
        })
    }
    function otpSubmit(otp: string) {
        setLoading(true);
        submitOtp(otp,phone).then((data: any) => {
            setLoading(false)
            if(data.login) {
                console.log(data)
                sessionStorage.setItem('me', JSON.stringify(data.user[0]));
                props.history.push('/');
            } else {
                let errorMessage = '';
                switch(data.reason) {
                    case 'PIN':
                        errorMessage = 'Pin is incorrect!';
                        break;
                    case 'EMAIL':
                        errorMessage = 'Seems like the your email is not registered!';
                        break;
                    case 'NOT_REG':
                        errorMessage = 'Your account is not active, contact our admin!';
                        break;
                    default:
                        errorMessage = 'Something went wrong!'
                }
                showErrorSnackbar(
                    snackbar,
                    errorMessage,
                    true
                );
            }
        }).catch(err => {
            setLoading(false);
            console.log(err);
        })
    }

    useEffect(() => {
        logout();
        sessionStorage.clear();
        
        window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('sign-in-button', {
            'size': 'invisible',
            'callback': () => {
              // reCAPTCHA solved, allow signInWithPhoneNumber.
              window.recaptchaVerifier.reset()
            }
          });
    }, []);

    const classes = styles();
        
    return (
        <div className={classes.column}>
            <div className={classes.RowLeft}>
                <div className={classes.invoiceapp}>Invoice App</div>
                <img alt="svganim" src="/img/personlogo.svg" style={{width:"300px",marginTop:"70px" }}/>
            </div>
            <form className={classes.RowRight} onSubmit={formik.handleSubmit}>
                <div className={classes.login}>Login</div>
                <div>
                <label htmlFor="">{ formik.touched.email && formik.errors.email ? <span>{formik.errors.email}</span> : null }</label>
                <br/>
                <input className={classes.inputtext} {...formik.getFieldProps('number')} onFocus={(e: any) => e.target.select()} placeholder="Phone Number"/>
                </div>
                <div>
                <label htmlFor="">{ formik.touched.pin && formik.errors.pin ? <span>{formik.errors.pin}</span> : null }</label>
                <br/>
                {otpContainer?<input className={classes.inputtext} onFocus={(e: any) => e.target.select()} onChange={(e:any)=>{setOtp(e.target.value)}} type="otp" placeholder="OTP"/>:null}
                </div>
                <div id="recaptcha-container"></div>
                {!otpContainer?<div><Button className={classes.buttonlog} type="submit" id="sign-in-button">Login</Button></div>:
                <div><Button className={classes.buttonlog} onClick={()=>{otpSubmit(otp)}}>Submit Otp</Button></div>}
            </form>
            <Loading loading={loading} text="Authenticating...."/>
        </div>

    )
}
